import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const BranchingIcon = ({
  color = 'black80',
  width = 22,
  marginLeft,
  marginRight,
  containerSize,
  title,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.53671 10.5658C0.755666 11.3468 0.755666 12.6132 1.53671 13.3942L10.566 22.4235C11.3471 23.2045 12.6134 23.2045 13.3944 22.4235L22.4237 13.3942C23.2048 12.6132 23.2048 11.3468 22.4237 10.5658L13.3944 1.53647C12.6134 0.755421 11.3471 0.755422 10.566 1.53647L1.53671 10.5658ZM11.5599 6.43956C11.361 6.15256 10.9367 6.15256 10.7379 6.43956L8.93856 9.03666C8.70882 9.36826 8.94615 9.82141 9.34956 9.82141H10.5129V18.5665H11.7849V17.0416L14.7725 14.054L15.6361 14.9177C15.9245 15.206 16.4182 15.0465 16.4833 14.6439L16.9799 11.5715C17.0343 11.2348 16.7432 10.9436 16.4065 10.9981L13.3341 11.4947C12.9315 11.5598 12.772 12.0535 13.0603 12.3419L13.873 13.1546L11.7849 15.2427V9.82141H12.9482C13.3516 9.82141 13.5889 9.36826 13.3592 9.03666L11.5599 6.43956Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
